import React from "react"
import { Navigate } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import Configs from "../config"
import ClubsIndex from "pages/Clubs"
import AddClub from "pages/Clubs/AddClub"
import EditClub from "pages/Clubs/EditClub"
import UserIndex from "pages/Users/UserIndex"
import PaymentsIndex from "pages/Payments"
import AddUser from "pages/Users/Adduser"
import EditUser from "pages/Users/Edituser"
import ActivityReport from "pages/Reports/ActivityReport"
import PlansIndex from "pages/Plans/PlanIndex"
import PlanHistory from "pages/Reports/PlanHistory"
import CalendarIndex from "pages/Calendar"
import WorkoutIndex from "pages/Workouts"
import LibraryIndex from "pages/Library"
import UserPlanIndex from "pages/UserPlan/Index"
import UserQuery from "pages/UserQuery"
import SocialMedia from "pages/SocialMedia"
import SeasonIndex from "pages/Season"
import LeagueIndex from "pages/League"
import NewCalender from "pages/Calendar/UserCalendar"
import ActivityOverview from "pages/ActivityOverview"

const authProtectedRoutes = [
  { path: `${Configs.appurl}dashboard`, component: <Dashboard /> },

  //Clubs
  { path: `${Configs.appurl}clubs`, component: <ClubsIndex /> },
  { path: `${Configs.appurl}add-club`, component: <AddClub /> },
  { path: `${Configs.appurl}edit-club/:slug`, component: <EditClub /> },

  //Users
  { path: `${Configs.appurl}users`, component: <UserIndex /> },
  { path: `${Configs.appurl}add-user`, component: <AddUser /> },
  { path: `${Configs.appurl}edit-user/:slug`, component: <EditUser /> },

  //Plans
  // { path: `${Configs.appurl}activities`, component: <PlansIndex /> },

  //Reports
  { path: `${Configs.appurl}activity-report`, component: <ActivityReport /> },
  { path: `${Configs.appurl}plan-history`, component: <PlanHistory /> },

  //Payments
  { path: `${Configs.appurl}payments`, component: <PaymentsIndex /> },

  //profile
  { path: `${Configs.appurl}profile`, component: <UserProfile /> },

  //Calendar
  { path: `${Configs.appurl}calendar`, component: <CalendarIndex /> },
  { path: `${Configs.appurl}calendar1`, component: <NewCalender /> },

  // Workout
  { path: `${Configs.appurl}workouts`, component: <WorkoutIndex /> },

  // Library
  { path: `${Configs.appurl}library`, component: <LibraryIndex /> },

  // User Plan
  { path: `${Configs.appurl}user-plan`, component: <UserPlanIndex /> },

  // User Query
  { path: `${Configs.appurl}user-query`, component: <UserQuery /> },

  // Social Media
  { path: `${Configs.appurl}social-media`, component: <SocialMedia /> },

  // Season Management
  { path: `${Configs.appurl}seasons`, component: <SeasonIndex /> },

  // League Management
  { path: `${Configs.appurl}league`, component: <LeagueIndex /> },

  // Activity Overview
  { path: `${Configs.appurl}activity-overview`, component: <ActivityOverview /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: `${Configs.appurl}`,
    exact: true,
    component: <Navigate to="dashboard" />,
  },
]

const publicRoutes = [
  { path: `${Configs.appurl}logout`, component: <Logout /> },
  { path: `${Configs.appurl}login`, component: <Login /> },
  { path: `${Configs.appurl}forgot-password`, component: <ForgetPwd /> },
  { path: `${Configs.appurl}register`, component: <Register /> },
]

export { authProtectedRoutes, publicRoutes }
